module.exports = __webpack_public_path__ + "img/security.7c309019.png";